import React, {useCallback, useContext, useState, useMemo, useEffect} from "react";
import { useMediaQuery } from 'react-responsive'
import Markup from '../../markup';
import BuilderContext from '../../builder/hooks/context';
import useExporter from "../../builder/hooks/useExporter";
import { device } from '../../const/device';
import ModalWrapper from "../Global/ModalWrapper";

function MemberList() {

    const { builder } = useContext(BuilderContext);
    const exporter = useExporter(builder);
    const isTablet = useMediaQuery({ query: `(${device.tablet})` });
    const MAX_MEMBERS_COUNT = 99;
    const [isCartAdd, setIsCartAdd] = useState<boolean>(false);
    const [index, setIndex] = useState<number>(0);
    const [modalIsOpen, changeModalState] = useState<boolean>(false);
    const [desktopSelectedYPosition, setDesktopSelectedYPosition] = useState<number>(0);

    const addButtonOnToggle = () => {
        (isTablet && !modalIsOpen) && changeModalState(true);
        !isTablet && builder.membersData.addMember();
        (isTablet && modalIsOpen) && builder.membersData.addMember();
        setIsCartAdd(true);
        !isTablet && builder.firstUpdateShCompMessage(false);
        (isTablet && builder.isMobShowCompMessage) && builder.firstUpdateShCompMessage(true);
    }
    const onSuccess = (res?: boolean, key?: string, messageBtn?: string, messageUnBtn?: string, countCart?: number, savedBuildsId?: number): void => {
        setIsCartAdd(false);
        builder.membersData.members[builder.membersData.currentMemberIndex].removeKey = key;
        builder.membersData.members[builder.membersData.currentMemberIndex].savedBuildsId = savedBuildsId;
        builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart = res;
        builder.membersData.members[builder.membersData.currentMemberIndex].messageBtn = messageBtn;
        builder.membersData.members[builder.membersData.currentMemberIndex].messageUnBtn = messageUnBtn;
        builder.updateAddCart(false);
        builder.setSaveBuilderState(false);
        builder.upCustCoun(countCart);
    }

    const onSuccessDelete = (countCart?: number):void => {
        if(countCart === 0 ){
            setIsCartAdd(true);
        }
        builder.upCustCoun(countCart);
    }

    const onError = (message: string | undefined = "An error occured, please try again later") => {
        builder.setSaveBuilderState(false);
    }

    const builderMemberRequest = (nameAction, action, index = 0) => {
        const exporterAction = async (data, onSuccess, onError) => {
            try {
                if (nameAction === "onSubmit") {
                    action(data, onSuccess, onError);
                }
            } catch (e) {
                onError(e);
            }
        };
        exporter(exporterAction, onSuccess, onError);
    };

    const onSubmit = (data, onSuccess, onError) => {
        window['builderOnSubmit'](data, onSuccess, onError);
    }

    const onDelCartItem = (data = '', key, usId = 0, onSuccessDelete, onError) =>{
        window['deleteItemOnCart'](data, key, usId, onSuccessDelete, onError);
    }

    const onModalClose = () => {
        changeModalState(false);
        builder.firstUpdateShCompMessage(false);
    }

    const onMemberClick = (event, index) => {
        if(event.target?.dataset?.name === "remove"){
            if(builder.membersData.members[index].removeKey !== undefined){
                setIndex(builder.membersData.members[index].removeKey);
            }
            builder.membersData.removeMember(index);
            return;
        }
        setIsCartAdd(true);
        isTablet ? changeModalState(true) : builder.membersData.selectMember(index);
    }

    const getMemberTitle = (member, index) => member?.text?.title?.value ? member?.text?.title?.value : "Gamer" + String(index+1).padStart(2, "0");

    const desktopContainerRef = useCallback(node => {
        if (node !== null) {
            const height = ((desktopSelectedYPosition - node?.getBoundingClientRect()?.top)-10);
            height > 0 && node?.scroll(0, height)
        }
    }, [desktopSelectedYPosition]);

    useEffect(() => {
        const hasBridgeFunctions =
          typeof (window as any).builderSaveDesign === 'function' &&
          typeof (window as any).builderAddToCartBatch === 'function';

        if (hasBridgeFunctions) {
            // Batch flow handles everything via "GO TO CART" — skip per-member submission
            return;
        }

        // Legacy per-member submission
        if(isCartAdd){
            builder.setSaveBuilderState(true);
            builderMemberRequest("onSubmit",onSubmit);
        }else if(builder.membersData.members.length === 1){
            setIsCartAdd(true);
        }else if(builder.membersData.members.length > 1){
            setIsCartAdd(true);
        }
    },[builder.addCart]);

    useEffect( () => {
        if(builder.membersData.editAction === true){
            //builderMemberRequest("onDelCartItem",onDelCartItem,builder.membersData.members[index]);
            onDelCartItem( '',index, builder.curentUserid, onSuccessDelete, onError);
        }else if(index !== 0){
            onDelCartItem( '',index, builder.curentUserid, onSuccessDelete, onError);
        }
    },[builder.membersData.members.length])

    const MobileMemberItem = (member, index) => (
        <Markup.Global.SelectBox.MobileMemberItemWrap>
            <Markup.Global.SelectBox.MobileMemberItemContent onClick={ () => {
                    builder.membersData.selectMember(index);
                    onModalClose();
                }}>
                <Markup.Builder.MemberRenderSelectMobile image={member?.preview}/>
                {getMemberTitle(member, index)}
                <Markup.Screen.ModalCpMembers.IconAssetMember enabled={builder.isFirstShCompMessage} checkAddCart={builder.membersData.members[index].resultAddedCart}/>
            </Markup.Global.SelectBox.MobileMemberItemContent>
            {builder.membersData.members.length > 1 && !builder.membersData.editAction &&
              <Markup.Builder.MemberRemoveMobile onClick={() => builder.membersData.removeMember(index)} />
            }
        </Markup.Global.SelectBox.MobileMemberItemWrap>
    )

    const MemberContainer = React.memo(() => (
        <Markup.BaseLayout.MemberContainer>
            <Markup.BaseLayout.MemberList ref={desktopContainerRef}>
                {builder.membersData.members.map((member, i) => ((isTablet && builder.membersData.currentMemberIndex === i) || !isTablet) &&
                    <Markup.Builder.MemberItem
                        key={i}
                        onClick={(e) => onMemberClick(e, i)}
                        active={builder.membersData.currentMemberIndex === i}
                        hasRemove={builder.membersData.members.length > 1 && !isTablet}
                        ref={(ref) => (builder.membersData.currentMemberIndex === i) && setDesktopSelectedYPosition(ref?.getBoundingClientRect()?.top)}
                    >
                        <Markup.Builder.MemberRender image={member?.preview}/>
                        <Markup.Builder.MemberName>{getMemberTitle(member, i)}</Markup.Builder.MemberName>
                        <Markup.Screen.ModalCpMembers.IconAssetMember enabled={builder.isFirstShCompMessage} checkAddCart={builder.membersData.members[i].resultAddedCart}/>
                        {(builder.membersData.members.length > 1 && !isTablet) && <Markup.Builder.MemberRemoveDesktop data-key={builder.membersData.members[i].removeKey} data-name="remove" />}
                    </Markup.Builder.MemberItem>
                )}
            </Markup.BaseLayout.MemberList>

            {<Markup.Global.Button.AdditionButton disable={builder.membersData.members.length >= MAX_MEMBERS_COUNT ? "true" : "false"} onClick={addButtonOnToggle}/>}
        </Markup.BaseLayout.MemberContainer>
    ))

    return (
        <>
            <MemberContainer/>
            {(isTablet && modalIsOpen) &&
                <ModalWrapper
                    modalOnToogle={changeModalState}
                    modalStatus={modalIsOpen}
                >
                    <Markup.Global.SelectBox.TitleContainer>
                        <Markup.Global.SelectBox.TitleText>
                            ADDED USERS
                            <Markup.Global.Button.ButtonIconClose onClick={onModalClose} />
                        </Markup.Global.SelectBox.TitleText>
                    </Markup.Global.SelectBox.TitleContainer>

                    <Markup.Global.SelectBox.MembersContainer>
                        {builder.membersData.members.map((member, index) => (
                            <Markup.Global.SelectBox.MobileItem
                                key={getMemberTitle(member, index)}
                                selected={builder.membersData.currentMemberIndex === index}
                                children={MobileMemberItem(member, index)}
                                ref={(ref) => builder.membersData.currentMemberIndex === index && ref?.scrollIntoView()}
                            />
                        ))}
                    </Markup.Global.SelectBox.MembersContainer>

                    {!builder.membersData.editAction &&
                        <Markup.Global.SelectBox.FooterContainer disable={builder.membersData.members.length >= MAX_MEMBERS_COUNT ? "true" : "false"} onClick={addButtonOnToggle}>
                            ADD ANOTHER PLAYER +
                        </Markup.Global.SelectBox.FooterContainer>
                    }
                </ModalWrapper>
            }
        </>
    );
}

export default React.memo(MemberList);